/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'
import * as AdminDefs from '../admin/defs.defs.js'
import * as RepoStrongRef from '../repo/strongRef.defs.js'

const $nsid = 'com.atproto.moderation.createReport'

export { $nsid }

/** Submit a moderation report regarding an atproto account or record. Implemented by moderation services (with PDS proxying), and requires auth. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    reasonType: l.ref<ModerationDefs.ReasonType>(
      (() => ModerationDefs.reasonType) as any,
    ),
    reason: l.optional(l.string({ maxGraphemes: 2000, maxLength: 20000 })),
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
      ],
      false,
    ),
    modTool: l.optional(l.ref<ModTool>((() => modTool) as any)),
  }),
  l.jsonPayload({
    id: l.integer(),
    reasonType: l.ref<ModerationDefs.ReasonType>(
      (() => ModerationDefs.reasonType) as any,
    ),
    reason: l.optional(l.string({ maxGraphemes: 2000, maxLength: 20000 })),
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
      ],
      false,
    ),
    reportedBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

/** Moderation tool information for tracing the source of the action */
type ModTool = {
  $type?: 'com.atproto.moderation.createReport#modTool'

  /**
   * Name/identifier of the source (e.g., 'bsky-app/android', 'bsky-web/chrome')
   */
  name: string

  /**
   * Additional arbitrary metadata about the source
   */
  meta?: l.LexMap
}

export type { ModTool }

/** Moderation tool information for tracing the source of the action */
const modTool = l.typedObject<ModTool>(
  $nsid,
  'modTool',
  l.object({ name: l.string(), meta: l.optional(l.lexMap()) }),
)

export { modTool }
